import { useFlag } from '@afterpaytouch/feature'
import { useCheckoutState, useGiftCardPromoBreakdown, useIsAfterpayAppGiftCardFlow, useMerchantDisplayNameOrName } from '..'
import { Features } from '../../model/features'
import { GiftCardDetails, parseGiftCardDetails } from './parseGiftCardDetails'
import { GiftCardRecipient, parseGiftCardRecipient } from './parseGiftCardRecipient'

export type { GiftCardDetails } from './parseGiftCardDetails'
export type { GiftCardRecipient } from './parseGiftCardRecipient'

export const useIsGiftCardSummaryCardEnabled = (): boolean => {
  const isGiftCardFlow = useIsAfterpayAppGiftCardFlow()
  const promotionUiEnabled = useFlag<boolean>(Features.CHECKOUT_GIFT_CARD_PROMOTION_UI_ENABLED, false)

  return isGiftCardFlow && promotionUiEnabled === true
}

export const useGiftCardDetails = (): GiftCardDetails => {
  const { checkout, started } = useCheckoutState()
  const merchantName = useMerchantDisplayNameOrName()
  const promotion = useGiftCardPromoBreakdown()
  const parsed = parseGiftCardDetails(checkout?.custom)

  return {
    name: parsed.name ?? (merchantName.length > 0 ? merchantName : null),
    imageUrl: parsed.imageUrl,
    faceValue: parsed.faceValue ?? promotion?.faceValue ?? started?.consumerAmount ?? checkout?.amount ?? null,
  }
}

export const useGiftCardRecipient = (): GiftCardRecipient | null => {
  const { checkout } = useCheckoutState()

  return parseGiftCardRecipient(checkout?.custom, checkout?.consumer)
}
